import { render, staticRenderFns } from "./ContactUsCardComponent.vue?vue&type=template&id=a5a6f3e0&scoped=true"
import script from "./ContactUsCardComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactUsCardComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContactUsCardComponent.vue?vue&type=style&index=0&id=a5a6f3e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a6f3e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5a6f3e0')) {
      api.createRecord('a5a6f3e0', component.options)
    } else {
      api.reload('a5a6f3e0', component.options)
    }
    module.hot.accept("./ContactUsCardComponent.vue?vue&type=template&id=a5a6f3e0&scoped=true", function () {
      api.rerender('a5a6f3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SupportServiceDialog/ContactUsCardComponent.vue"
export default component.exports